import React, { memo, FC } from 'react';
import clsx from 'clsx';
import styles from './skeleton.module.css';

export const getSkeletonRandom = (maxWidth: number) => {
    const minWidth = maxWidth * 0.4;
    const randomValue = Math.random();
    const randomNumber = Math.floor(randomValue * minWidth);

    return randomNumber + (maxWidth - minWidth);
};

type Skeleton = {
    width: string;
    height?: string;
    className?: string;
    variant?: 'light' | 'inverted';
    children?: React.ReactNode;
    style?: React.CSSProperties;
    aspectRatio?: string;
};

export const Skeleton: FC<Skeleton> = memo(
    ({ children, width, height, className, variant = 'light', style, aspectRatio }) => (
        <div
            className={clsx(styles[variant], className)}
            style={{ width, height, aspectRatio, ...style }}
            suppressHydrationWarning
        >
            {children}
        </div>
    )
);
